import type ArrowBack from '@mui/icons-material/ArrowBack';
import type ArrowForward from '@mui/icons-material/ArrowForward';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { Button } from '../../Button/Button.tsx';

const ARROW_BUTTON_SIZE = 32;

type ArrowButtonProps = {
  dataTest?: string;
  disabled?: boolean;
  Icon: typeof ArrowBack | typeof ArrowForward;
  onTransfer: () => void;
  tooltipText: string;
};

export const ArrowButton = ({ dataTest, disabled, Icon, onTransfer, tooltipText }: ArrowButtonProps) => (
  <Tooltip title={tooltipText}>
    <Box>
      <Button
        data-test={dataTest}
        disabled={disabled}
        onClick={onTransfer}
        sx={{
          height: `${ARROW_BUTTON_SIZE}px`,
          maxWidth: `${ARROW_BUTTON_SIZE}px`,
          minWidth: `${ARROW_BUTTON_SIZE}px`,
        }}
      >
        <Icon />
      </Button>
    </Box>
  </Tooltip>
);
